export const items = [
  {
    number: '01',
    title: 'SHOE SALE',
    img: '/React-Portfolio/images/projectIMG/shoe-img.png',
    website: 'https://danielkai0107.github.io/Practice-copycat-01/',
    github: 'https://github.com/Danielkai0107/Practice-copycat-01',
    figma: '',
  },
  {
    number: '02',
    title: 'PET CARE',
    img: '/React-Portfolio/images/projectIMG/pet-img.png',
    website: 'https://danielkai0107.github.io/Practice-copycat-02/',
    github: 'https://github.com/Danielkai0107/Practice-copycat-02',
    figma: '',
  },
  {
    number: '03',
    title: 'DESSERT ANIMATE',
    img: '/React-Portfolio/images/projectIMG/dessert-img.png',
    website: 'https://danielkai0107.github.io/Practice-copycat-03/',
    github: 'https://github.com/Danielkai0107/Practice-copycat-03',
    figma: '',
  },
  {
    number: '04',
    title: 'SHOPPING CART',
    img: '/React-Portfolio/images/projectIMG/shopping-img.png',
    website: 'https://danielkai0107.github.io/Shopping-Cart/',
    github: 'https://github.com/Danielkai0107/Shopping-Cart',
    figma:
      'https://www.figma.com/file/K1gVvS9WJRB79SbltXeFpo/ShopCart?node-id=0%3A1',
  },
  {
    number: '05',
    title: 'WEATHER APP',
    img: '/React-Portfolio/images/projectIMG/weather-img.png',
    website: 'https://danielkai0107.github.io/Weather/',
    github: 'https://github.com/Danielkai0107/Weather',
    figma:
      'https://www.figma.com/file/DkAa0lG987eAv43Vwft8BK/Weather?node-id=0%3A1',
  },
  {
    number: '06',
    title: 'MOVIEFinder',
    img: '/React-Portfolio/images/projectIMG/movie-img.png',
    website: 'https://danielkai0107.github.io/movie-final/',
    github: 'https://github.com/Danielkai0107/movie-final',
    figma:
      'https://www.figma.com/file/akpQOTlVUP3IDUDgNt2Bv9/MovieFinder?node-id=0%3A1',
  },
];
